export const Soc = (props) => {
    return (
        <div className="modal fade" id="modal-requi-soc" tabIndex="-1" role="dialog" aria-labelledby="modal-requi-soc" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title" id="modal-requi-soc">{props.data ? props.data.name1 : 'loading'}</h5>
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="modal-body">
                    <div>
                        <h4>Requisitos</h4>
                        
                        <div className="requi-text">
                        <ul>
                                  {props.data
                                  ? props.data.requires1.map((d, i) => (
                                      <li key={`${d}-${i}`}> {d}</li>
                                      ))
                                  : 'cargando'}
                              </ul>   
                        </div>  
                        <h4>NOTA: En el caso de extranjeros, acreditar su legal estancia en el país:</h4>
                        <div className="requi-text">
                        <ul>
                                  {props.data
                                  ? props.data.requires2.map((d, i) => (
                                      <li key={`${d}-${i}`}> {d}</li>
                                      ))
                                  : 'cargando'}
                              </ul>   
                        </div>  
                  </div>
                <div className="modal-footer">
                  <a className='navbar-brand page-scroll' href='#page-top'>
                  <img src='img/logo-leut.png'alt='...' className='team-img-nav' />
                  </a>
                    <a href="pdf/Soc.pdf" type="button" className="btn btn-requi-modal btn-lg" target="_blank">Descargar Requisitos</a>
                    <h4>Formatos para constitución de...</h4>
                    <a href="pdf/CSA.pdf" type="button" className="btn btn-requi-modal btn-lg" target="_blank">SOCIEDAD ANONIMA</a>
                    <a href="pdf/CSRL.pdf" type="button" className="btn btn-requi-modal btn-lg" target="_blank">SOCIEDAD DE RESPONSABILIDAD LIMITADA</a>
                    <a href="pdf/CSAPI.pdf" type="button" className="btn btn-requi-modal btn-lg" target="_blank">SOCIEDAD PROMOTORA DE INVERSION SAPI</a>
                </div>
                </div>
            </div>
        </div>
    </div>
      )
    }   